import { Component } from "react";
import Logo from "../asset/images/Logo.png"
import { Link } from "react-router-dom";

class Header extends Component {
    state = {
        user: []
    }
    componentDidMount() {
        const savedUser = localStorage.getItem("teslaUserInfo");
        // const accessToken = localStorage.getItem("teslaUserAccessToken");
        if (savedUser) {
            const userData = JSON.parse(savedUser);
            this.setState({
                user: {
                    firstName: userData.firstName || "",
                    lastName: userData.lastName || "",
                    userPlan: userData.userPlan || ""
                }
            });
        }
    }


    render() {
        const {user} = this.state
        return (
            <header className="landing">
                <div className="head_container">
                    <section className="head_cover">
                        <img src={Logo} alt="logo" />
                    </section>
                    <section className="head_cover">
                        {
                            user && Object.keys(user).length > 0
                                ?<Link to="/dashboard"><button className="color">Dashbaord</button></Link>:
                                <>
                                    <Link to="/login"><button>Sign In</button></Link>
                                    <Link to="/signup"><button className="color">Get Started</button></Link>
                                </> 
                                
                        }
                    </section>
                </div>
            </header>
        )
    }
}


export default Header